// dependency-graph-ignore-file
import { type Database } from '@databases/model/database';

export function setShowFieldDescription(
  ydb: Database,
  fieldId: string,
  showDescription: boolean
): void {
  ydb.mutate((db) => {
    const field = db.fieldsById[fieldId];
    field.showDescription = showDescription;
  });
}
